module.exports = __webpack_public_path__ + "img/shield.a17ddba3.png";